
<icon class="security" v-tooltip="'Sensitive data'"></icon>
